import router from '../../app/router'
import Home from '@/components/activeOver'
/*import Home from './pages/home/index'
import Details from './pages/details/index'
import Rule from './pages/rule/index'
import PaySuccess from './pages/paySuccess/index'*/

const routes = [
  /*{
    path: '/huoliIOUSecKill/paySuccess',
    name: 'huoliIOUSecKill/paySuccess',
    component: PaySuccess,
    meta: {
      title: ''
    }
  },
  {
    path: '/huoliIOUSecKill/rule',
    name: 'huoliIOUSecKill/rule',
    component: Rule,
    meta: {
      title: '活动规则'
    }
  },
  {
    path: '/huoliIOUSecKill/details',
    name: 'huoliIOUSecKill/details',
    component: Details,
    meta: {
      title: '优惠券详情'
    }
  },*/
  {
    path: '/huoliIOUSecKill/*',
    name: 'huoliIOUSecKill',
    component: Home,
    meta: {
      title: '白条'
    }
  }
]

router.addRoutes(routes)

export default router



// WEBPACK FOOTER //
// ./src/projects/huoliIOUSecKill/router.js